'use strict';

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.array.for-each");

var Mixin = module.exports = function (host) {
  var originalMethods = {},
      overriddenMethods = this._getOverriddenMethods(this, originalMethods);

  Object.keys(overriddenMethods).forEach(function (key) {
    if (typeof overriddenMethods[key] === 'function') {
      originalMethods[key] = host[key];
      host[key] = overriddenMethods[key];
    }
  });
};

Mixin.prototype._getOverriddenMethods = function () {
  throw new Error('Not implemented');
};